export default __webpack_public_path__ + "static/Simple_Bullet-340d3d4844a99d3c157b97b7b69cca8f.png";